import { Component } from '@angular/core';
import { AlertController, ViewController } from 'ionic-angular';
import { BrComService } from '../../service/BrComService';
import { config } from '../../shared/config';

@Component({
  selector: 'menu-popup',
  templateUrl: 'menu-popover.html'
})
export class MenuPopoverComponent {


  constructor(private alertController: AlertController,
    private brComService: BrComService,
    private viewController: ViewController) {

  }

  public sair() {
    const alerta = this.alertController.create({
      title: "AVISO",
      message: "Você tem certeza que deseja sair?",
      buttons: [{
        text: "Cancelar",
        role: "cancel"
      },{
        text: "Confirmar",
        handler:  () => {
          this.brComService.limparEDeslogarServidor();
          this.viewController.dismiss();
//          this.navCtrl.setRoot(LoginWebPage);
 //         this.navCtrl.popToRoot();
       //   this.removerAutenticacao();
        }
      }]
    });
    alerta.present();
  }

  getVersao() {
    return config.versao;
  }

}



// WEBPACK FOOTER //
// ./src/components/menu-popup/menu-popover.ts